<template>
  <el-form :model="form" size="small" :rules="rules" ref="form" label-width="90px" class="form-horizontal flex-column prepend-equal dicts-create-form">
    <div class="flex-row flex-wrap justify-content-between form-row">
      <el-form-item prop="type" label="数据类型">
        <el-select v-model="form.type" filterable placeholder="请选择" @change="changeFormType" :disabled="formType !== '新增'" style="width: 100%;">
          <el-option v-for="item in dataTypesArr" :key="item.value" :label="item.text" :value="item.value">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item prop="name" label="字典编码">
        <el-input v-model.trim="form.name" placeholder="不能重复" :disabled="formType !== '新增'"></el-input>
      </el-form-item>
      <el-form-item prop="value" label="字典值">
        <el-input v-model.trim="form.value" placeholder="不能重复" :disabled="isShow"></el-input>
      </el-form-item>
      <el-form-item prop="description" label="说明">
        <el-input v-model="form.description" placeholder="说明" :disabled="isShow"></el-input>
      </el-form-item>
    </div>
    <div class="text-center p-t-sm" v-if="!isShow">
      <el-button class="submit-btn" @click="submitForm" v-loading="submitLoading" >确定</el-button>
      <el-button class="cancel-btn" @click="handleClose">取消</el-button>
    </div>
  </el-form>
</template>

<script>
import { mapActions } from 'vuex'

export default {
  name: 'dictBasicalForm',
  props: {
    formType: {
      type: String,
      default: ''
    },
    dataTypesArr: {
      type: Array,
      default: []
    },
    dict: {
      type: Object,
      default: null,
    },
    modalShow: {
      type: Boolean,
      default: false
    }
  },
  data() {
    var validatePass = (rule, value, callback) => {
      if (isNaN(value)) {
        callback(new Error('请输入数字值'))
      } else {
        callback()
      }
    }
    return {
      submitLoading: false,
      form: {
        id: '',
        name: '',
        description: '',
        type: '',
        value: ''
      },
      rules: {
        name: [
          {
            validator: validatePass,
            trigger: 'blur, change'
          }, {
            required: true,
            message: '请输入字典编码',
            trigger: 'blur'
          }
        ],
        value: [{
          required: true,
          message: '请输入字典值',
          trigger: 'blur'
        }],
        type: [{
          required: true,
          message: '请选择数据类型',
          trigger: 'blur, change'
        }]
      },
    }
  },
  computed: {
    isShow() {
      return this.formType === '详情'
    }
  },
  watch: {
    modalShow(to) {
      this.$refs.form.resetFields()
      if (this.dict !== null) {
        this.form = {
          ...this.form,
          ...this.dict
        }
      }
    }
  },
  mounted() {
    if (this.dict !== null) {
      this.form = {
        ...this.dict
      }
    }
  },
  methods: {
    ...mapActions(['fetchData']),
    changeFormType(v) {
      this.form.name = ''
      this.form.value = ''
    },
    submitForm() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          let url = "SYSTEM.DICT.POST_ADD_OR_UPDATE";
          let params = {
            ...this.form
          }
          for (let i = 0; i < this.dataTypesArr.length; i++) {
            if (this.dataTypesArr[i].value == params.type) {
              params.typeName = this.dataTypesArr[i].text
            }
          }
          if (!params.id) delete params.id
          this.submitLoading = true
          this.fetchData({ url, method: 'post', params, flag: true, headers: { 'Content-Type': 'application/json' } }).then(res => {
            if (res && res.code == 200) {
              this.$message.success(res.msg || '操作成功')
              this._finishOperate()
            } else {
              let tipMsg = (res && res.msg) ? res.msg : '操作失败'
              this.$message.error(tipMsg)
            }
          }).catch(err => {
            this.$message.error(err || '操作失败！')
          }).finally(() => {
            this.submitLoading = false
          })
        } else {
          return false;
        }
      });
    },
    // 处理取消按钮点击
    handleCancel() {
      this.$emit('close')
    },
    _finishOperate() {
      this.submitLoading = false
      this.$emit('success')
    },
    handleClose() {
      this.$emit('close')
    }
  }

}
</script>

<style lang="less" scoped>
.tips {
  color: red;
}
.bottom-btn {
  margin: 0px 10px;
}
</style>
